import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListContractTypes } from "../../../components/Admin/ContractTypes/ListContractTypes/ListContractTypes";
import { useLanguage } from "../../../contexts";
import "./ContractTypes.scss";

export function ContractTypes() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    { menuItem: t("actives"),   render: () => <Tab.Pane attached={false}><ListContractTypes active={true}  reload={reload} onReload={onReload} /></Tab.Pane> },
    { menuItem: t("inactives"), render: () => <Tab.Pane attached={false}><ListContractTypes active={false} reload={reload} onReload={onReload} /></Tab.Pane> },
  ];

  return (
    <div className="contract-types-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="contract-types-page-header-wrapper">
        <div className="contract-types-page-header">
          <span className="contract-types-page-title">{t("contract_types")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
